/** Normalize doctor display name for comparison (strip Dr., lowercase, collapse spaces). */
export function normalizeDoctorName(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/^(dr\.?\s*)+/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Whether a queue row belongs to the logged-in doctor (manager sees all). */
export function doctorQueueMatch(row, user) {
  if (!row || !user) return false;
  if (user.role === 'manager') return true;
  // Prefer exact staff id match when the queue row carries one
  if (row.doctorId && user.staffId) return row.doctorId === user.staffId;
  const rowDoc = normalizeDoctorName(row.doctor);
  const userName = normalizeDoctorName(user.name);
  if (!rowDoc || !userName) return false;
  if (rowDoc === userName) return true;
  // Loose fallback only when one side is a partial of the other's full name
  // (e.g. "anita rao" vs "anita r rao") — never match on shared surname alone.
  const rowParts = rowDoc.split(/\s+/);
  const userParts = userName.split(/\s+/);
  const shorter = rowParts.length <= userParts.length ? rowParts : userParts;
  const longerStr = rowParts.length <= userParts.length ? userName : rowDoc;
  return shorter.length >= 2 && shorter.every((p) => longerStr.includes(p));
}

/** Display doctor name once with Dr. prefix (avoids "Dr. Dr. Name"). */
export function formatDoctorLabel(name) {
  if (!name) return '—';
  const t = String(name).trim();
  if (/^dr\.?\s/i.test(t)) return t;
  return `Dr. ${t}`;
}
